module.exports = __webpack_public_path__ + "img/universal_edit.89363f07.svg";